/*
 * @Date: 2024-03-15 17:22:32
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-30 15:24:40
 * @FilePath: /video-marketing/components/icons/index.tsx
 */
import { memo } from 'react';

/** 模板/媒体预览失败态（与 library TaskCard 视觉一致，避免 ai-viral-template 依赖 library 路径） */
export const TemplateMediaErrorIcon = memo(() => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    className="shrink-0"
    aria-hidden
  >
    <path
      d="M15 11.5488V15.4377M15 23.75C10.1675 23.75 6.25 19.8325 6.25 15C6.25 10.1675 10.1675 6.25 15 6.25C19.8325 6.25 23.75 10.1675 23.75 15C23.75 19.8325 19.8325 23.75 15 23.75ZM15.0484 18.3544V18.4516L14.9516 18.4512V18.3544H15.0484Z"
      stroke="#FC5132"
      strokeWidth="1.55556"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
TemplateMediaErrorIcon.displayName = 'TemplateMediaErrorIcon';

export const MoreIcon = ({ className }: { className: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className={className}
    >
      <g filter="url(#filter0_b_2959_9225)">
        <rect y="-0.00012207" width="24" height="24" rx="4" fill="none" />
      </g>
      <path
        d="M12.75 11.9999C12.75 12.4141 12.4142 12.7499 12 12.7499C11.5858 12.7499 11.25 12.4141 11.25 11.9999C11.25 11.5857 11.5858 11.2499 12 11.2499C12.4142 11.2499 12.75 11.5857 12.75 11.9999Z"
        stroke="#F8F8F8"
        strokeWidth="1.5"
      />
      <path
        d="M7 11.9999C7 12.4141 6.66421 12.7499 6.25 12.7499C5.83579 12.7499 5.5 12.4141 5.5 11.9999C5.5 11.5857 5.83579 11.2499 6.25 11.2499C6.66421 11.2499 7 11.5857 7 11.9999Z"
        stroke="#F8F8F8"
        strokeWidth="1.5"
      />
      <path
        d="M18.5 11.9999C18.5 12.4141 18.1642 12.7499 17.75 12.7499C17.3358 12.7499 17 12.4141 17 11.9999C17 11.5857 17.3358 11.2499 17.75 11.2499C18.1642 11.2499 18.5 11.5857 18.5 11.9999Z"
        stroke="#F8F8F8"
        strokeWidth="1.5"
      />
      <defs>
        <filter
          id="filter0_b_2959_9225"
          x="-4"
          y="-4.00012"
          width="32"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2959_9225"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2959_9225"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const DownloadIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 12.3333L12 16M12 16L16 12.3333M12 16V5M4 14V17C4 18.1046 4.89543 19 6 19H18C19.1046 19 20 18.1046 20 17V14"
        stroke="#7A7A7A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const EditIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.5 20L7.0944 20C7.35451 20 7.60438 19.8987 7.791 19.7175L17.9233 9.87969M3.5 20L3.5 16.4085C3.5 16.1467 3.60271 15.8953 3.78606 15.7083L13.6721 5.62842M3.5 20L20 20M13.6721 5.62842L15.0863 4.2142C15.8673 3.43316 17.1337 3.43316 17.9147 4.2142L19.3375 5.63705C20.1186 6.4181 20.1186 7.68443 19.3375 8.46548L17.9233 9.87969M13.6721 5.62842L17.9233 9.87969"
        stroke="#7A7A7A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RenameIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 20L7.0944 20C7.35451 20 7.60438 19.8987 7.791 19.7175L17.9233 9.87969M3.5 20L3.5 16.4085C3.5 16.1467 3.60271 15.8953 3.78606 15.7083L13.6721 5.62842M3.5 20L20 20M13.6721 5.62842L15.0863 4.2142C15.8673 3.43316 17.1337 3.43316 17.9147 4.2142L19.3375 5.63705C20.1186 6.4181 20.1186 7.68443 19.3375 8.46548L17.9233 9.87969M13.6721 5.62842L17.9233 9.87969"
        stroke="#7A7A7A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DeleteIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5 7L5.86732 19.1425C5.94208 20.1891 6.81296 21 7.86224 21H16.1378C17.187 21 18.0579 20.1891 18.1327 19.1425L19 7M5 7H9M5 7C5 7 3.39052 7 3 7M19 7H15M19 7H21M9 7H15M9 7V6C9 4.34315 10.3431 3 12 3V3C13.6569 3 15 4.34315 15 6V7M10 11V16M14 11V16"
        stroke="#EA5538"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const HoverPlayIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1618 9.57378C15.3963 8.88797 15.3963 7.11262 14.1618 6.42681L3.46823 0.485942C2.26847 -0.180589 0.794067 0.686953 0.794067 2.05942V13.9412C0.794067 15.3136 2.26847 16.1812 3.46822 15.5147L14.1618 9.57378Z"
        fill="#F8F8F8"
      />
    </svg>
  );
};

export const UserIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9973 11.1834C14.0939 11.1834 15.8029 9.54078 15.8029 7.54143C15.8029 5.55762 14.1116 4 11.9973 4C9.90942 4 8.19173 5.5887 8.19173 7.55697C8.20038 9.54838 9.90942 11.1834 11.9973 11.1834Z"
        stroke="#7A7A7A"
        strokeWidth="1.5"
      />
      <path
        d="M11.9973 13.3067C15.2513 13.3067 19.9706 15.1542 18.8245 18.0972C18.7166 18.3742 17.0742 20 12.0018 20C6.92934 20 5.27937 18.3742 5.17865 18.1196C4.01572 15.1795 8.7896 13.3067 11.9973 13.3067Z"
        stroke="#7A7A7A"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export const LogoutIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 5L6 5C4.89543 5 4 5.89543 4 7L4 17C4 18.1046 4.89543 19 6 19H13M8 12L19 12M19 12L16 9M19 12L16 15"
        stroke="#7A7A7A"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const CreditIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.40757 6.34393C9.53475 5.85771 9.97551 5.5 10.5 5.5C11.0245 5.5 11.4652 5.8577 11.5924 6.34392C11.8226 7.2237 12.1907 7.87193 12.6748 8.35091C13.1591 8.83015 13.8142 9.19418 14.7026 9.41956C15.1633 9.53641 15.5 9.95209 15.5 10.4445C15.5 11.001 15.1217 11.4667 14.61 11.6047C13.7464 11.8375 13.1087 12.2054 12.6364 12.6877C12.1636 13.1705 11.8039 13.8218 11.5804 14.7026C11.4636 15.1632 11.0479 15.5 10.5555 15.5C9.99904 15.5 9.53327 15.1217 9.39532 14.61C9.1625 13.7463 8.7946 13.1086 8.31232 12.6364C7.82952 12.1636 7.17822 11.8039 6.29737 11.5804C5.83677 11.4636 5.5 11.0479 5.5 10.5555C5.5 9.99904 5.87833 9.53327 6.39005 9.39532C7.24619 9.16452 7.88014 8.80098 8.35091 8.32525C8.82193 7.84926 9.18139 7.2086 9.40757 6.34393Z"
        fill="white"
        stroke="white"
        strokeWidth="0.8"
      />
    </svg>
  );
};

export const HomeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M9.16699 1.27637C9.32417 1.27636 9.49059 1.29038 9.64941 1.32324C9.79767 1.35395 9.9908 1.41151 10.166 1.52832C10.1719 1.53223 10.1778 1.53597 10.1836 1.54004L15.5156 5.31738H15.5146C16.1305 5.73599 16.5 6.43222 16.5 7.17773V13.875C16.5 15.5319 15.1569 16.875 13.5 16.875H4.5C2.84315 16.875 1.5 15.5319 1.5 13.875V7.17773C1.50001 6.42545 1.87602 5.72296 2.50195 5.30566L8.16797 1.52832L8.30176 1.45117C8.43694 1.38437 8.5734 1.34627 8.68457 1.32324C8.8434 1.29037 9.0098 1.27637 9.16699 1.27637Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.85 13.05C8.3103 13.05 9.6897 13.05 12.15 13.05"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);
export const HomeSelectedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M2.25 7.17777C2.25 6.67624 2.50065 6.20789 2.91795 5.92969L8.58397 2.15234C8.8359 1.98439 9.49808 1.98437 9.75 2.15232L15.082 5.92969C15.4993 6.20789 15.75 6.67624 15.75 7.17777V13.875C15.75 15.1176 14.7426 16.125 13.5 16.125H4.5C3.25736 16.125 2.25 15.1176 2.25 13.875V7.17777Z"
      fill="white"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.85 13.05C8.3103 13.05 9.6897 13.05 12.15 13.05"
      stroke="#161616"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);
export const ViralTemplateIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fill="currentColor"
      d="M8.51562 2.5H3.28125C3.07405 2.5 2.87534 2.58231 2.72882 2.72882C2.58231 2.87534 2.5 3.07405 2.5 3.28125V8.51562C2.5 8.72283 2.58231 8.92154 2.72882 9.06805C2.87534 9.21456 3.07405 9.29688 3.28125 9.29688H8.51562C8.72283 9.29688 8.92154 9.21456 9.06805 9.06805C9.21456 8.92154 9.29688 8.72283 9.29688 8.51562V3.28125C9.29688 3.07405 9.21456 2.87534 9.06805 2.72882C8.92154 2.58231 8.72283 2.5 8.51562 2.5ZM7.89062 7.89062H3.90625V3.90625H7.89062V7.89062ZM8.51562 10.7031H3.28125C3.07405 10.7031 2.87534 10.7854 2.72882 10.9319C2.58231 11.0785 2.5 11.2772 2.5 11.4844V16.7188C2.5 16.926 2.58231 17.1247 2.72882 17.2712C2.87534 17.4177 3.07405 17.5 3.28125 17.5H8.51562C8.72283 17.5 8.92154 17.4177 9.06805 17.2712C9.21456 17.1247 9.29688 16.926 9.29688 16.7188V11.4844C9.29688 11.2772 9.21456 11.0785 9.06805 10.9319C8.92154 10.7854 8.72283 10.7031 8.51562 10.7031ZM7.89062 16.0938H3.90625V12.1094H7.89062V16.0938ZM16.7188 10.7031H11.4844C11.2772 10.7031 11.0785 10.7854 10.9319 10.9319C10.7854 11.0785 10.7031 11.2772 10.7031 11.4844V16.7188C10.7031 16.926 10.7854 17.1247 10.9319 17.2712C11.0785 17.4177 11.2772 17.5 11.4844 17.5H16.7188C16.926 17.5 17.1247 17.4177 17.2712 17.2712C17.4177 17.1247 17.5 16.926 17.5 16.7188V11.4844C17.5 11.2772 17.4177 11.0785 17.2712 10.9319C17.1247 10.7854 16.926 10.7031 16.7188 10.7031ZM16.0938 16.0938H12.1094V12.1094H16.0938V16.0938ZM13.9844 2.30469C11.9355 2.30469 10.2734 3.9668 10.2734 6.01562C10.2734 8.06445 11.9355 9.72656 13.9844 9.72656C16.0332 9.72656 17.6953 8.06445 17.6953 6.01562C17.6953 3.9668 16.0332 2.30469 13.9844 2.30469ZM15.6133 7.64453C15.2365 8.0204 14.7411 8.25404 14.2115 8.30567C13.6818 8.35729 13.1506 8.22371 12.7084 7.92766C12.2662 7.63162 11.9402 7.19143 11.7861 6.68205C11.632 6.17268 11.6592 5.62563 11.8631 5.13408C12.0671 4.64252 12.4351 4.23686 12.9045 3.98619C13.374 3.73551 13.9158 3.65532 14.4377 3.75928C14.9596 3.86324 15.4294 4.14491 15.767 4.55632C16.1045 4.96773 16.289 5.48345 16.2891 6.01562C16.2899 6.31837 16.2306 6.61826 16.1146 6.89789C15.9986 7.17753 15.8282 7.43132 15.6133 7.64453Z"
    />
  </svg>
);

export const AIVideoGenerate = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.62339 4.05335C9.79217 4.05335 9.95403 4.12 10.0734 4.23865C10.1927 4.3573 10.2598 4.51823 10.2598 4.68602C10.2598 4.85382 10.1927 5.01474 10.0734 5.13339C9.95403 5.25204 9.79217 5.3187 9.62339 5.3187H2.62334C2.45456 5.3187 2.2927 5.38535 2.17336 5.504C2.05402 5.62265 1.98697 5.78357 1.98697 5.95137V16.0741C1.98697 16.2419 2.05402 16.4029 2.17336 16.5215C2.2927 16.6402 2.45456 16.7068 2.62334 16.7068H15.3507C15.5195 16.7068 15.6813 16.6402 15.8007 16.5215C15.92 16.4029 15.9871 16.2419 15.9871 16.0741V11.0128C15.9871 10.845 16.0541 10.684 16.1735 10.5654C16.2928 10.4467 16.4547 10.3801 16.6234 10.3801C16.7922 10.3801 16.9541 10.4467 17.0734 10.5654C17.1928 10.684 17.2598 10.845 17.2598 11.0128V16.0741C17.2598 16.5775 17.0587 17.0603 16.7007 17.4163C16.3426 17.7722 15.857 17.9722 15.3507 17.9722H2.62334C2.11701 17.9722 1.63142 17.7722 1.2734 17.4163C0.915371 17.0603 0.714233 16.5775 0.714233 16.0741V5.95137C0.714233 5.44798 0.915371 4.96521 1.2734 4.60927C1.63142 4.25332 2.11701 4.05335 2.62334 4.05335H9.62339ZM15.0134 2.25402C15.0771 1.87822 15.6205 1.87822 15.6842 2.25402L15.7478 2.63236C15.8433 3.20497 16.1165 3.73357 16.5291 4.14423C16.9417 4.55488 17.4731 4.82704 18.0489 4.92264L18.4307 4.98591C18.8087 5.04918 18.8087 5.58821 18.4307 5.65148L18.0489 5.71475C17.4731 5.81035 16.9417 6.08251 16.5291 6.49316C16.1165 6.90382 15.8433 7.43242 15.7478 8.00503L15.6842 8.38337C15.6205 8.75917 15.0771 8.75917 15.0134 8.38337L14.9498 7.99997C14.8533 7.42828 14.5797 6.9008 14.1672 6.49113C13.7547 6.08146 13.2238 5.81005 12.6487 5.71475L12.2669 5.65148C11.8889 5.58821 11.8889 5.04918 12.2669 4.98591L12.6487 4.92264C13.2238 4.82735 13.7547 4.55593 14.1672 4.14626C14.5797 3.73659 14.8533 3.20911 14.9498 2.63742L15.0134 2.25402Z"
      fill="currentColor"
    />
    <path
      d="M10.9642 10.5396C11.2973 10.732 11.2973 11.2123 10.9642 11.4048L7.96423 13.1372C7.63101 13.3296 7.2145 13.0893 7.21423 12.7046L7.21423 9.23975C7.2145 8.85506 7.63101 8.61474 7.96423 8.80713L10.9642 10.5396Z"
      stroke="currentColor"
    />
  </svg>
);

export const AIVideoEdit = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M9.62339 15.9722C9.79217 15.9722 9.95403 15.9055 10.0734 15.7869C10.1927 15.6682 10.2598 15.5073 10.2598 15.3395C10.2598 15.1717 10.1927 15.0108 10.0734 14.8921C9.95403 14.7735 9.79217 14.7068 9.62339 14.7068H2.62334C2.45456 14.7068 2.2927 14.6402 2.17336 14.5215C2.05402 14.4029 1.98697 14.2419 1.98697 14.0741V3.95137C1.98697 3.78357 2.05402 3.62265 2.17336 3.504C2.2927 3.38535 2.45456 3.3187 2.62334 3.3187H15.3507C15.5195 3.3187 15.6813 3.38535 15.8007 3.504C15.92 3.62265 15.9871 3.78357 15.9871 3.95137V9.01276C15.9871 9.18055 16.0541 9.34148 16.1735 9.46012C16.2928 9.57877 16.4547 9.64543 16.6234 9.64543C16.7922 9.64543 16.9541 9.57877 17.0734 9.46012C17.1928 9.34148 17.2598 9.18055 17.2598 9.01276V3.95137C17.2598 3.44798 17.0587 2.96521 16.7007 2.60927C16.3426 2.25332 15.857 2.05335 15.3507 2.05335H2.62334C2.11701 2.05335 1.63142 2.25332 1.2734 2.60927C0.915371 2.96521 0.714233 3.44798 0.714233 3.95137V14.0741C0.714233 14.5775 0.915371 15.0603 1.2734 15.4163C1.63142 15.7722 2.11701 15.9722 2.62334 15.9722H9.62339Z"
      fill="currentColor"
    />
    <path
      d="M10.9642 8.53955C11.2973 8.73203 11.2973 9.2123 10.9642 9.40479L7.96423 11.1372C7.63101 11.3296 7.2145 11.0893 7.21423 10.7046L7.21423 7.23975C7.2145 6.85506 7.63101 6.61474 7.96423 6.80713L10.9642 8.53955Z"
      stroke="currentColor"
    />
    <path
      d="M12.1542 14.873L15.541 11.4863C15.6951 11.3321 15.8781 11.2098 16.0794 11.1264C16.2808 11.0429 16.4966 11 16.7146 11C16.9326 11 17.1484 11.0429 17.3498 11.1264C17.5511 11.2098 17.7341 11.3321 17.8882 11.4863L18.5142 12.1123C18.8253 12.4235 19 12.8454 19 13.2853C19 13.7252 18.8253 14.1471 18.5142 14.4583L15.1263 17.845C14.9185 18.0527 14.6593 18.2016 14.3752 18.2764L11.6929 18.982C11.5995 19.0064 11.5013 19.006 11.4081 18.9807C11.3149 18.9553 11.2299 18.9061 11.1617 18.8377C11.0934 18.7694 11.0443 18.6843 11.0191 18.5911C10.9939 18.4978 10.9936 18.3996 11.0182 18.3062L11.7228 15.624C11.7974 15.3395 11.9463 15.08 12.1542 14.8719V14.873ZM14.0943 17.2068C14.1888 17.1818 14.2751 17.1322 14.3442 17.063L17.7322 13.6763C17.8359 13.5726 17.8941 13.4319 17.8941 13.2853C17.8941 13.1387 17.8359 12.998 17.7322 12.8943L17.1051 12.2683C17.0013 12.1646 16.8607 12.1064 16.7141 12.1064C16.5674 12.1064 16.4268 12.1646 16.3231 12.2683L12.9362 15.655C12.867 15.7242 12.8174 15.8104 12.7924 15.905L12.3278 17.6713L14.0943 17.2068Z"
      fill="currentColor"
    />
  </svg>
);

export const AIImageGenerate = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M16.344 3C17.673 3 18.75 4.056 18.75 5.357V16.143C18.75 17.444 17.673 18.5 16.344 18.5H3.656C2.327 18.5 1.25 17.444 1.25 16.143V10.656C1.25 10.4819 1.31917 10.3149 1.44228 10.1918C1.5654 10.0687 1.73239 9.9995 1.9065 9.9995C2.08061 9.9995 2.2476 10.0687 2.37072 10.1918C2.49383 10.3149 2.563 10.4819 2.563 10.656V12.777C2.85243 12.735 3.14453 12.7139 3.437 12.714C4.80504 12.7103 6.13269 13.1775 7.197 14.037C8.256 11.33 10.92 9.5 13.936 9.5C15.284 9.5 16.541 9.837 17.436 10.343V5.357C17.4361 5.21582 17.4078 5.07606 17.3528 4.94602C17.2979 4.81599 17.2173 4.69832 17.116 4.6C16.9098 4.39752 16.632 4.28466 16.343 4.286H10.643C10.4787 4.27683 10.3241 4.20509 10.211 4.08551C10.0979 3.96593 10.0349 3.80759 10.0349 3.643C10.0349 3.47841 10.0979 3.32007 10.211 3.20049C10.3241 3.08091 10.4787 3.00917 10.643 3H16.343H16.344ZM13.937 10.786C11.44 10.786 9.239 12.318 8.392 14.576L8.104 15.352C8.06567 15.4513 8.004 15.5399 7.92421 15.6103C7.84442 15.6807 7.74885 15.7309 7.64558 15.7566C7.5423 15.7823 7.43436 15.7828 7.33087 15.7579C7.22738 15.7331 7.13139 15.6837 7.051 15.614C6.80878 15.3997 6.56172 15.191 6.31 14.988C5.49099 14.3451 4.47919 13.997 3.438 14C3.141 14 2.848 14.027 2.562 14.081V16.143C2.56192 16.2842 2.59021 16.4239 2.64518 16.554C2.70015 16.684 2.78068 16.8017 2.882 16.9C3.08844 17.1027 3.36667 17.2156 3.656 17.214H16.344C16.6326 17.2134 16.9097 17.1008 17.117 16.9C17.2175 16.801 17.2974 16.6832 17.3523 16.5534C17.4073 16.4235 17.436 16.284 17.437 16.143V11.995C17.328 11.828 17.004 11.56 16.542 11.334C15.84 10.99 14.943 10.786 13.937 10.786Z"
      fill="currentColor"
    />
    <path
      d="M2.97594 1.94509C3.03844 1.57384 3.57219 1.57384 3.63469 1.94509L3.69719 2.31884C3.791 2.88451 4.05929 3.4067 4.46451 3.81237C4.86973 4.21804 5.39163 4.4869 5.95719 4.58134L6.33219 4.64384C6.70344 4.70634 6.70344 5.23884 6.33219 5.30134L5.95719 5.36384C5.39163 5.45829 4.86973 5.72715 4.46451 6.13282C4.05929 6.53849 3.791 7.06068 3.69719 7.62634L3.63469 8.00009C3.57219 8.37134 3.03844 8.37134 2.97594 8.00009L2.91344 7.62134C2.81867 7.05659 2.54997 6.53551 2.14482 6.13081C1.73967 5.72611 1.21829 5.45798 0.653437 5.36384L0.278437 5.30134C-0.0928125 5.23884 -0.0928125 4.70634 0.278437 4.64384L0.653437 4.58134C1.21829 4.4872 1.73967 4.21908 2.14482 3.81438C2.54997 3.40968 2.81867 2.8886 2.91344 2.32384L2.97594 1.94509Z"
      fill="currentColor"
    />
    <path
      d="M6.67502 10.883L6.76802 10.67C6.93002 10.295 7.22702 9.994 7.60002 9.827L7.88502 9.7C7.91883 9.68362 7.94735 9.65805 7.9673 9.62622C7.98726 9.59438 7.99784 9.55757 7.99784 9.52C7.99784 9.48243 7.98726 9.44562 7.9673 9.41378C7.94735 9.38195 7.91883 9.35638 7.88502 9.34L7.61502 9.22C7.23267 9.04807 6.93092 8.73594 6.77202 8.348L6.67602 8.119C6.66178 8.084 6.63743 8.05403 6.60608 8.03294C6.57473 8.01185 6.53781 8.00058 6.50002 8.00058C6.46223 8.00058 6.42531 8.01185 6.39395 8.03294C6.3626 8.05403 6.33825 8.084 6.32402 8.119L6.22902 8.349C6.06902 8.736 5.76702 9.049 5.38402 9.22L5.11502 9.34C5.08121 9.35638 5.05269 9.38195 5.03273 9.41378C5.01278 9.44562 5.0022 9.48243 5.0022 9.52C5.0022 9.55757 5.01278 9.59438 5.03273 9.62622C5.05269 9.65805 5.08121 9.68362 5.11502 9.7L5.40002 9.827C5.77302 9.994 6.07002 10.295 6.23202 10.67L6.32502 10.883C6.33956 10.9174 6.36392 10.9467 6.39504 10.9674C6.42616 10.988 6.46268 10.999 6.50002 10.999C6.53736 10.999 6.57387 10.988 6.605 10.9674C6.63612 10.9467 6.66048 10.9174 6.67502 10.883Z"
      fill="currentColor"
    />
  </svg>
);

export const VideoTransitionIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <g clipPath="url(#clip0_101_2362)">
      <path
        d="M7.444 17.625C7.32452 17.5056 7.2298 17.3638 7.16527 17.2077C7.10073 17.0516 7.06765 16.8843 7.06793 16.7154V11.5746H8.35268V16.513C8.3526 16.5576 8.36749 16.601 8.39496 16.6362L8.41296 16.656C8.43186 16.6752 8.45443 16.6903 8.47932 16.7005C8.50421 16.7107 8.53091 16.7158 8.55781 16.7154H16.5047C16.5577 16.7154 16.6085 16.6944 16.646 16.6569C16.6834 16.6194 16.7045 16.5686 16.7045 16.5157V8.56786C16.7045 8.54163 16.6993 8.51565 16.6893 8.49142C16.6792 8.46719 16.6645 8.44517 16.646 8.42663C16.6274 8.40808 16.6054 8.39337 16.5812 8.38333C16.5569 8.37329 16.531 8.36813 16.5047 8.36813H11.5664V7.08428L16.7072 7.07708C16.8761 7.0768 17.0434 7.10988 17.1994 7.17442C17.3555 7.23895 17.4973 7.33367 17.6167 7.45315C17.7362 7.57254 17.8309 7.71435 17.8955 7.87044C17.96 8.02653 17.9931 8.19382 17.9928 8.36273V16.7163C17.9931 16.8852 17.96 17.0525 17.8955 17.2086C17.8309 17.3647 17.7362 17.5065 17.6167 17.6259C17.4973 17.7454 17.3555 17.8401 17.1994 17.9046C17.0434 17.9692 16.8761 18.0022 16.7072 18.002H8.35088C8.18237 18.0018 8.01554 17.9684 7.85994 17.9037C7.70433 17.839 7.56299 17.7443 7.444 17.625ZM1.28565 12.8567H2.5704C2.5704 13.1942 2.63689 13.5285 2.76606 13.8403C2.89524 14.1522 3.08457 14.4355 3.32325 14.6742C3.56194 14.9129 3.8453 15.1022 4.15715 15.2314C4.46901 15.3606 4.80325 15.4271 5.1408 15.4271V16.7118C4.11866 16.712 3.13827 16.3064 2.41517 15.5839C1.69207 14.8615 1.28547 13.8815 1.28475 12.8594L1.28565 12.8567ZM14.1188 15.3992L13.7319 14.3195H11.7175L11.3306 15.3992H10.2861L12.1314 10.2917H13.4314L15.2254 15.3992H14.1188ZM11.9937 13.4666H13.4584L12.7665 11.2858H12.7386L11.9937 13.4666ZM9.63923 10.9259H1.28565C1.11675 10.9262 0.949452 10.8931 0.793362 10.8286C0.637273 10.7641 0.495464 10.6693 0.37607 10.5499C0.256597 10.4305 0.161875 10.2887 0.0973399 10.1326C0.0328045 9.97648 -0.00027423 9.80919 1.71273e-06 9.64028V1.2876C-0.000273916 1.11891 0.0327206 0.951825 0.0970968 0.795902C0.161473 0.639979 0.255967 0.498282 0.37517 0.378921C0.494276 0.2595 0.63576 0.164736 0.791528 0.100052C0.947295 0.0353673 1.11429 0.00203201 1.28295 0.00195312H9.64103C9.80969 0.00203201 9.97668 0.0353673 10.1325 0.100052C10.2882 0.164736 10.4297 0.2595 10.5488 0.378921C10.668 0.498282 10.7625 0.639979 10.8269 0.795902C10.8913 0.951825 10.9243 1.11891 10.924 1.2876V9.64028C10.9243 9.80919 10.8912 9.97648 10.8266 10.1326C10.7621 10.2887 10.6674 10.4305 10.5479 10.5499C10.3074 10.7904 9.98121 10.9257 9.64103 10.9259H9.63923ZM1.30005 9.62589H9.62663V1.3029H1.30275L1.30005 9.62589ZM4.19073 8.1693C4.03281 8.08618 3.8987 7.96415 3.80109 7.81474C3.70349 7.66534 3.64561 7.49351 3.63293 7.31549C3.5537 6.17505 3.54769 5.0307 3.61494 3.88949L3.63473 3.5782C3.65464 3.31373 3.77349 3.06648 3.96758 2.88573C4.16167 2.70497 4.41674 2.604 4.68196 2.60294H4.75754C4.90899 2.61402 5.05628 2.65759 5.18938 2.7307C6.10655 3.23788 6.97563 3.82751 7.78588 4.49228C7.92262 4.60453 8.03359 4.74491 8.11121 4.90389C8.18884 5.06287 8.2313 5.2367 8.23572 5.41356C8.24008 5.5903 8.20634 5.76591 8.13679 5.92844C8.06724 6.09098 7.96351 6.23665 7.83266 6.35553L7.82096 6.36633L7.78138 6.40051L7.76518 6.41311C7.37382 6.719 6.96536 7.0132 6.55691 7.2948C6.11966 7.5944 5.66712 7.8778 5.20738 8.145C5.04641 8.23938 4.86316 8.28908 4.67657 8.28895C4.50764 8.28995 4.34097 8.25013 4.19073 8.17289V8.1693ZM4.64058 3.64928L4.62078 3.94887C4.55637 5.04634 4.56238 6.14682 4.63878 7.24352C4.63953 7.25164 4.64232 7.25944 4.64687 7.2662C4.65143 7.27296 4.65762 7.27847 4.66487 7.28221C4.67217 7.28622 4.68037 7.28833 4.68871 7.28833C4.69705 7.28833 4.70525 7.28622 4.71255 7.28221C5.56128 6.78888 6.37475 6.23724 7.1471 5.63128L7.16689 5.61419C7.19115 5.59115 7.21014 5.56315 7.22256 5.53209C7.23498 5.50104 7.24054 5.46766 7.23887 5.43425C7.23768 5.4014 7.22953 5.36916 7.21495 5.3397C7.20037 5.31023 7.1797 5.28419 7.1543 5.26331C6.78261 4.95602 6.39651 4.66659 5.9973 4.39602C5.58045 4.11291 5.1513 3.84931 4.70985 3.60519C4.70378 3.60172 4.69703 3.59957 4.69006 3.59889C4.68298 3.59845 4.67588 3.59957 4.66928 3.60217C4.66267 3.60476 4.65671 3.60878 4.65183 3.61392C4.64694 3.61907 4.64324 3.62522 4.64098 3.63195C4.63873 3.63868 4.63798 3.64582 4.63878 3.65288L4.64058 3.64928ZM15.4242 5.14725C15.4242 4.8097 15.3577 4.47546 15.2285 4.1636C15.0994 3.85175 14.91 3.56839 14.6714 3.3297C14.4327 3.09102 14.1493 2.90169 13.8375 2.77251C13.5256 2.64334 13.1914 2.57685 12.8538 2.57685V1.2894C13.8763 1.2894 14.8568 1.69557 15.5798 2.41855C16.3028 3.14153 16.709 4.1221 16.709 5.14455L15.4242 5.14725Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_101_2362">
        <rect width="18" height="18" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

export const ImageTransitionIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      d="M9.3578 19C9.18868 19.0003 9.02116 18.9672 8.86486 18.9026C8.70857 18.838 8.56657 18.7432 8.44701 18.6236C8.32746 18.504 8.23271 18.362 8.1682 18.2057C8.10369 18.0494 8.07069 17.8819 8.0711 17.7128V11.9289H2.28671C2.11762 11.9293 1.95012 11.8963 1.79383 11.8318C1.63753 11.7673 1.49553 11.6725 1.37596 11.553C1.2564 11.4335 1.16164 11.2915 1.09712 11.1352C1.0326 10.979 0.999597 10.8115 1 10.6424V2.2872C0.999598 2.11811 1.0326 1.95061 1.09711 1.79431C1.16162 1.63801 1.25637 1.49598 1.37592 1.37638C1.49547 1.25678 1.63747 1.16197 1.79377 1.09738C1.95007 1.03279 2.11758 0.999697 2.28671 1H10.6437C10.8127 0.9999 10.98 1.03315 11.1361 1.09784C11.2922 1.16253 11.4339 1.25739 11.5533 1.37697C11.6726 1.49656 11.7671 1.63853 11.8315 1.79472C11.8958 1.95092 11.9286 2.11828 11.9281 2.2872V8.07113H17.7141C17.8831 8.07072 18.0506 8.10372 18.2068 8.16824C18.3631 8.23275 18.505 8.32751 18.6245 8.44705C18.744 8.5666 18.8387 8.70858 18.9032 8.86484C18.9676 9.02109 19.0005 9.18854 19 9.35756V17.7128C19.0005 17.8819 18.9676 18.0493 18.9032 18.2056C18.8387 18.3619 18.7441 18.504 18.6246 18.6236C18.5051 18.7432 18.3631 18.838 18.2069 18.9026C18.0506 18.9672 17.8831 19.0003 17.7141 19H9.3578ZM9.3578 17.0707C9.3577 17.155 9.37422 17.2385 9.40641 17.3164C9.4386 17.3943 9.48583 17.4651 9.5454 17.5247C9.60497 17.5843 9.67572 17.6316 9.75359 17.6639C9.83146 17.6962 9.91493 17.7128 9.99923 17.7128H17.0726C17.243 17.7128 17.4063 17.6452 17.5267 17.5247C17.6472 17.4043 17.7148 17.241 17.7148 17.0707V10.0004C17.7148 9.83003 17.6472 9.66664 17.5268 9.54611C17.4064 9.42558 17.243 9.35776 17.0726 9.35756H11.9289V10.6432C11.9294 10.8121 11.8965 10.9794 11.8322 11.1356C11.7679 11.2917 11.6733 11.4336 11.554 11.5532C11.4346 11.6727 11.2929 11.7675 11.1368 11.8321C10.9807 11.8967 10.8134 11.9298 10.6445 11.9296H9.35857L9.3578 17.0707ZM2.92505 10.6424H9.99846C10.1687 10.642 10.3319 10.5743 10.4524 10.454C10.5729 10.3337 10.6408 10.1706 10.6414 10.0004V8.80711L8.35601 6.62842L6.65041 9.34986C6.60458 9.42312 6.54414 9.48615 6.47287 9.53503C6.40159 9.58391 6.32101 9.61757 6.23614 9.63393C6.15118 9.64969 6.06392 9.64805 5.97961 9.62913C5.8953 9.61021 5.81571 9.57439 5.74564 9.52384L4.14939 8.3552L2.30134 10.1143C2.32805 10.2612 2.4052 10.3942 2.51948 10.4904C2.63376 10.5865 2.77802 10.6397 2.92736 10.6409L2.92505 10.6424ZM2.47228 2.47351C2.41199 2.53307 2.36419 2.60406 2.33166 2.68231C2.29914 2.76057 2.28255 2.84452 2.28286 2.92926V8.38908L3.65657 7.08494C3.76362 6.98321 3.90305 6.92236 4.05044 6.91307C4.19784 6.90378 4.34381 6.94664 4.46278 7.03413L5.93968 8.11193L7.69918 5.30888C7.74866 5.22981 7.81509 5.16272 7.89367 5.11245C7.97225 5.06218 8.06102 5.02999 8.15356 5.0182C8.2461 5.00642 8.34011 5.01533 8.42879 5.0443C8.51746 5.07327 8.5986 5.12157 8.66632 5.18571L10.6407 7.06646V2.93003C10.6407 2.84565 10.624 2.7621 10.5917 2.68415C10.5594 2.6062 10.512 2.53538 10.4523 2.47575C10.3926 2.41612 10.3217 2.36884 10.2437 2.33662C10.1657 2.3044 10.0821 2.28787 9.99769 2.28797H2.92505C2.75566 2.28896 2.59351 2.35674 2.47382 2.47659L2.47228 2.47351ZM2.28286 13.8551H3.56879C3.56879 14.5369 3.83965 15.1908 4.3218 15.673C4.80395 16.1552 5.45792 16.4262 6.13989 16.4264V17.7105C5.11741 17.7105 4.13679 17.3045 3.41364 16.5818C2.6905 15.8591 2.28404 14.8789 2.28363 13.8566L2.28286 13.8551ZM15.1229 16.3956L14.7379 15.3178H12.7213L12.3362 16.3956H11.2836L13.1317 11.286H14.4307L16.231 16.3956H15.1229ZM12.9954 14.4632H14.4584L13.7654 12.2845H13.7369L12.9954 14.4632ZM16.4266 6.1488C16.4266 5.46697 16.1557 4.81307 15.6736 4.33087C15.1914 3.84868 14.5375 3.57768 13.8555 3.57748V2.2872C14.8784 2.2872 15.8595 2.69348 16.5828 3.41666C17.3062 4.13984 17.7125 5.12068 17.7125 6.14341L16.4266 6.1488ZM3.69507 4.59985C3.69523 4.4217 3.74821 4.2476 3.84734 4.09956C3.94646 3.95152 4.08726 3.83619 4.25194 3.76816C4.41662 3.70012 4.59778 3.68244 4.77251 3.71734C4.94725 3.75225 5.1077 3.83817 5.23359 3.96425C5.35948 4.09033 5.44515 4.25089 5.47976 4.42565C5.51437 4.6004 5.49638 4.78149 5.42805 4.94602C5.35972 5.11055 5.24412 5.25113 5.09588 5.34998C4.94764 5.44882 4.77341 5.5015 4.59523 5.50135C4.47689 5.50135 4.35971 5.47802 4.2504 5.4327C4.14109 5.38737 4.04179 5.32094 3.95818 5.23721C3.87457 5.15348 3.8083 5.05409 3.76315 4.94472C3.71801 4.83535 3.69487 4.71816 3.69507 4.59985Z"
      fill="currentColor"
    />
  </svg>
);

export const ProductAvatar2 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M4.1333 5.71337C4.1333 4.72639 4.52538 3.77983 5.22328 3.08192C5.92119 2.38402 6.86775 1.99194 7.85473 1.99194C8.84171 1.99194 9.78827 2.38402 10.4862 3.08192C11.1841 3.77983 11.5762 4.72639 11.5762 5.71337C11.5762 6.70036 11.1841 7.64692 10.4862 8.34482C9.78827 9.04272 8.84171 9.4348 7.85473 9.4348C6.86775 9.4348 5.92119 9.04272 5.22328 8.34482C4.52538 7.64692 4.1333 6.70036 4.1333 5.71337ZM7.85425 3.3048C7.21559 3.3048 6.60308 3.55851 6.15147 4.01012C5.69987 4.46172 5.44616 5.07423 5.44616 5.7129C5.44616 6.35156 5.69987 6.96407 6.15147 7.41568C6.60308 7.86728 7.21559 8.12099 7.85425 8.12099C8.49292 8.12099 9.10543 7.86728 9.55703 7.41568C10.0086 6.96407 10.2623 6.35156 10.2623 5.7129C10.2623 5.07423 10.0086 4.46172 9.55703 4.01012C9.10543 3.55851 8.49292 3.3048 7.85425 3.3048Z"
      fill="currentColor"
    />
    <path
      d="M11.3839 10.5657C11.4169 10.5655 11.4494 10.5739 11.4782 10.5902C11.507 10.6064 11.5311 10.6298 11.5481 10.6582C11.5652 10.6865 11.5745 10.7188 11.5752 10.7518C11.576 10.7849 11.5681 10.8175 11.5524 10.8466L11.0486 11.779C11.0323 11.8092 11.0081 11.8345 10.9786 11.8521C10.9491 11.8697 10.9154 11.879 10.881 11.879H7.29624L6.63719 11.8847L6.09433 11.8962L5.78957 11.9085L5.5229 11.9247L5.29338 11.9447C5.25874 11.9485 5.22413 11.9526 5.18957 11.9571L5.00195 11.9857C4.94481 11.9952 4.88957 12.0066 4.83814 12.019L4.69148 12.059L4.55814 12.1057L4.43433 12.159C4.41433 12.1685 4.39433 12.1781 4.37433 12.1895C3.83889 12.462 3.40348 12.8971 3.13052 13.4323L3.07338 13.5552C3.06411 13.576 3.05522 13.5969 3.04671 13.6181L2.99909 13.7514L2.96005 13.8971C2.95361 13.9234 2.94758 13.9497 2.94195 13.9762L2.91148 14.1514C2.90666 14.1837 2.90221 14.2161 2.89814 14.2485L2.87529 14.4638L2.84957 14.8476L2.83719 15.1523L2.82576 15.6952L2.821 16.3552V16.6942H8.5429C8.57527 16.6942 8.60713 16.7024 8.63546 16.718C8.66378 16.7337 8.68765 16.7563 8.70481 16.7838C8.72197 16.8112 8.73184 16.8426 8.73351 16.8749C8.73518 16.9072 8.72858 16.9395 8.71433 16.9685L8.26005 17.9009C8.24447 17.9331 8.22013 17.9603 8.18981 17.9794C8.15949 17.9984 8.12442 18.0085 8.08862 18.0085H1.50671V16.319L1.51243 15.6542L1.52005 15.2685L1.52957 14.9257L1.54481 14.619L1.56386 14.3447L1.58862 14.1L1.61909 13.88L1.63719 13.7781L1.67814 13.5857C1.69233 13.5262 1.70821 13.4671 1.72576 13.4085L1.781 13.2409L1.84576 13.079L1.92005 12.9171L1.96005 12.8362C2.35875 12.0538 2.99484 11.4177 3.77719 11.019L3.86576 10.9752L4.03909 10.8971L4.12671 10.8609L4.30576 10.7981C4.48862 10.74 4.68671 10.6962 4.92481 10.6628L5.17529 10.6333L5.45814 10.6104L5.77719 10.5933L6.13814 10.5809L6.77052 10.5695L7.26005 10.5666L11.3839 10.5657Z"
      fill="currentColor"
    />
    <path
      d="M13.8204 12.4046C13.8171 12.2462 13.7512 12.0955 13.637 11.9856C13.5229 11.8757 13.3698 11.8155 13.2113 11.8182C13.0527 11.8152 12.8993 11.8752 12.7849 11.9852C12.6705 12.0951 12.6044 12.2459 12.6011 12.4046V16.6603C12.6011 16.983 12.8738 17.2455 13.2113 17.2455C13.5477 17.2455 13.8216 16.9841 13.8216 16.6591V12.4035V12.4046H13.8204ZM11.1284 14.9569C11.1269 14.8783 11.1099 14.8007 11.0784 14.7287C11.047 14.6567 11.0016 14.5916 10.9449 14.5371C10.8882 14.4826 10.8213 14.4399 10.7481 14.4113C10.6749 14.3827 10.5967 14.3688 10.5181 14.3705C10.4397 14.369 10.3616 14.383 10.2885 14.4116C10.2154 14.4403 10.1487 14.483 10.0921 14.5375C10.0356 14.592 9.99029 14.657 9.95888 14.729C9.92747 14.8009 9.91054 14.8784 9.90906 14.9569V16.6591C9.90906 16.983 10.1806 17.2455 10.5181 17.2455C10.6768 17.2485 10.8302 17.1885 10.9446 17.0786C11.059 16.9686 11.1251 16.8178 11.1284 16.6591V14.9569ZM15.9034 13.5239C16.2409 13.5239 16.5136 13.7853 16.5136 14.1091V16.6614C16.5124 16.7401 16.4957 16.8179 16.4643 16.8901C16.4329 16.9623 16.3876 17.0276 16.3309 17.0823C16.2741 17.1369 16.2071 17.1797 16.1338 17.2083C16.0604 17.2369 15.9821 17.2507 15.9034 17.2489C15.7447 17.2516 15.5915 17.1913 15.4773 17.0812C15.3631 16.971 15.2973 16.82 15.2943 16.6614V14.1091C15.2943 13.7864 15.567 13.5239 15.9034 13.5239Z"
      fill="currentColor"
    />
  </svg>
);

export const ProductAvatar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M14.4534 2.38098C14.8015 2.38108 15.1376 2.5083 15.3986 2.73873C15.6595 2.96917 15.8274 3.28696 15.8705 3.63241L16.8453 11.4286H15.4053L14.4529 3.80955H5.54672L3.9991 16.1905H10.9524V17.6191H4.00006C3.79749 17.6191 3.59724 17.576 3.41259 17.4927C3.22794 17.4094 3.06312 17.2878 2.92905 17.136C2.79499 16.9841 2.69475 16.8055 2.63499 16.612C2.57523 16.4184 2.55732 16.2144 2.58244 16.0134L4.13006 3.63241C4.17321 3.28705 4.34097 2.96932 4.60182 2.73889C4.86267 2.50847 5.19867 2.3812 5.54672 2.38098H14.4534ZM7.6191 6.19051C7.6191 6.82197 7.86995 7.42758 8.31647 7.87409C8.76298 8.32061 9.36859 8.57146 10.0001 8.57146C10.6315 8.57146 11.2371 8.32061 11.6836 7.87409C12.1302 7.42758 12.381 6.82197 12.381 6.19051H13.8096C13.8096 7.20085 13.4082 8.16982 12.6938 8.88425C11.9794 9.59867 11.0104 10 10.0001 10C8.98971 10 8.02074 9.59867 7.30631 8.88425C6.59189 8.16982 6.19053 7.20085 6.19053 6.19051H7.6191Z"
      fill="currentColor"
    />
    <path
      d="M14.7011 13.2527C14.7578 12.9158 15.2422 12.9158 15.299 13.2527L15.3557 13.5918C15.4408 14.1051 15.6843 14.579 16.0521 14.9471C16.4199 15.3153 16.8936 15.5593 17.4069 15.645L17.7473 15.7017C18.0842 15.7584 18.0842 16.2416 17.7473 16.2983L17.4069 16.355C16.8936 16.4407 16.4199 16.6847 16.0521 17.0529C15.6843 17.421 15.4408 17.8949 15.3557 18.4082L15.299 18.7473C15.2422 19.0842 14.7578 19.0842 14.7011 18.7473L14.6443 18.4036C14.5583 17.8911 14.3144 17.4183 13.9467 17.051C13.579 16.6838 13.1058 16.4405 12.5931 16.355L12.2527 16.2983C11.9158 16.2416 11.9158 15.7584 12.2527 15.7017L12.5931 15.645C13.1058 15.5595 13.579 15.3162 13.9467 14.949C14.3144 14.5817 14.5583 14.1089 14.6443 13.5964L14.7011 13.2527Z"
      fill="currentColor"
    />
  </svg>
);

export const MyAvatar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M4.1333 5.71337C4.1333 4.72639 4.52538 3.77983 5.22328 3.08192C5.92119 2.38402 6.86775 1.99194 7.85473 1.99194C8.84171 1.99194 9.78827 2.38402 10.4862 3.08192C11.1841 3.77983 11.5762 4.72639 11.5762 5.71337C11.5762 6.70036 11.1841 7.64692 10.4862 8.34482C9.78827 9.04272 8.84171 9.4348 7.85473 9.4348C6.86775 9.4348 5.92119 9.04272 5.22328 8.34482C4.52538 7.64692 4.1333 6.70036 4.1333 5.71337ZM7.85425 3.3048C7.21559 3.3048 6.60308 3.55851 6.15147 4.01012C5.69987 4.46172 5.44616 5.07423 5.44616 5.7129C5.44616 6.35156 5.69987 6.96407 6.15147 7.41568C6.60308 7.86728 7.21559 8.12099 7.85425 8.12099C8.49292 8.12099 9.10543 7.86728 9.55703 7.41568C10.0086 6.96407 10.2623 6.35156 10.2623 5.7129C10.2623 5.07423 10.0086 4.46172 9.55703 4.01012C9.10543 3.55851 8.49292 3.3048 7.85425 3.3048Z"
      fill="currentColor"
    />
    <path
      d="M11.3839 10.5657C11.4169 10.5655 11.4494 10.5739 11.4782 10.5902C11.507 10.6064 11.5311 10.6298 11.5481 10.6582C11.5652 10.6865 11.5745 10.7188 11.5752 10.7518C11.576 10.7849 11.5681 10.8175 11.5524 10.8466L11.0486 11.779C11.0323 11.8092 11.0081 11.8345 10.9786 11.8521C10.9491 11.8697 10.9154 11.879 10.881 11.879H7.29624L6.63719 11.8847L6.09433 11.8962L5.78957 11.9085L5.5229 11.9247L5.29338 11.9447C5.25874 11.9485 5.22413 11.9526 5.18957 11.9571L5.00195 11.9857C4.94481 11.9952 4.88957 12.0066 4.83814 12.019L4.69148 12.059L4.55814 12.1057L4.43433 12.159C4.41433 12.1685 4.39433 12.1781 4.37433 12.1895C3.83889 12.462 3.40348 12.8971 3.13052 13.4323L3.07338 13.5552C3.06411 13.576 3.05522 13.5969 3.04671 13.6181L2.99909 13.7514L2.96005 13.8971C2.95361 13.9234 2.94758 13.9497 2.94195 13.9762L2.91148 14.1514C2.90666 14.1837 2.90221 14.2161 2.89814 14.2485L2.87529 14.4638L2.84957 14.8476L2.83719 15.1523L2.82576 15.6952L2.821 16.3552V16.6942H8.5429C8.57527 16.6942 8.60713 16.7024 8.63546 16.718C8.66378 16.7337 8.68765 16.7563 8.70481 16.7838C8.72197 16.8112 8.73184 16.8426 8.73351 16.8749C8.73518 16.9072 8.72858 16.9395 8.71433 16.9685L8.26005 17.9009C8.24447 17.9331 8.22013 17.9603 8.18981 17.9794C8.15949 17.9984 8.12442 18.0085 8.08862 18.0085H1.50671V16.319L1.51243 15.6542L1.52005 15.2685L1.52957 14.9257L1.54481 14.619L1.56386 14.3447L1.58862 14.1L1.61909 13.88L1.63719 13.7781L1.67814 13.5857C1.69233 13.5262 1.70821 13.4671 1.72576 13.4085L1.781 13.2409L1.84576 13.079L1.92005 12.9171L1.96005 12.8362C2.35875 12.0538 2.99484 11.4177 3.77719 11.019L3.86576 10.9752L4.03909 10.8971L4.12671 10.8609L4.30576 10.7981C4.48862 10.74 4.68671 10.6962 4.92481 10.6628L5.17529 10.6333L5.45814 10.6104L5.77719 10.5933L6.13814 10.5809L6.77052 10.5695L7.26005 10.5666L11.3839 10.5657Z"
      fill="currentColor"
    />
    <path
      d="M17.7886 15.2476H16.381V18.0076H17.7876V15.2476H17.7886ZM14.381 13.5609L14.4257 15.2486H13.7029C13.3533 15.2486 13.0295 15.4171 12.9086 15.6838L12.6543 16.3457H14.4562L14.5 18.0076H15.9438L15.4895 12.8C15.4657 12.519 15.2076 12.3171 14.8981 12.3171H14.2362C13.3752 12.3171 12.5676 12.7857 12.2114 13.4971L9.95239 18.0076H10.8762C11.1952 18.0076 11.4952 17.8362 11.6286 17.5705L13.4857 13.9019C13.5438 13.7973 13.6291 13.7104 13.7325 13.6504C13.836 13.5904 13.9537 13.5595 14.0733 13.5609H14.38H14.381ZM17.0857 14.8362C17.5419 14.8362 17.92 14.5086 17.92 14.0962C17.92 13.6829 17.5419 13.3552 17.0848 13.3552C16.6276 13.3552 16.2495 13.6829 16.2495 14.0962C16.2495 14.5086 16.6286 14.8362 17.0848 14.8362H17.0857Z"
      fill="currentColor"
    />
  </svg>
);

export const FaceSwap = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.77072 1L6.05063 1C6.44912 1 6.77215 1.32304 6.77215 1.72152C6.77215 2.12 6.44912 2.44304 6.05063 2.44304H4.8C4.24931 2.44304 3.87968 2.4436 3.59504 2.46686C3.31882 2.48942 3.18675 2.52972 3.09963 2.57411C2.87336 2.6894 2.6894 2.87336 2.57411 3.09963C2.52972 3.18675 2.48942 3.31882 2.46686 3.59504C2.4436 3.87969 2.44304 4.24931 2.44304 4.8V6.05063C2.44304 6.44912 2.12 6.77215 1.72152 6.77215C1.32304 6.77215 1 6.44912 1 6.05063L1 4.77072C0.99999 4.25685 0.999982 3.82794 1.02861 3.47753C1.05847 3.11207 1.12303 2.76896 1.28835 2.44451C1.54199 1.94671 1.94671 1.54199 2.44451 1.28835C2.76896 1.12303 3.11207 1.05847 3.47753 1.02861C3.82793 0.999982 4.25685 0.99999 4.77072 1ZM7.64391 4.69779C4.01661 5.26137 1.24051 8.39826 1.24051 12.1835C1.24051 16.3676 4.63238 19.7595 8.81646 19.7595C12.6017 19.7595 15.7386 16.9834 16.3022 13.3561C18.4882 12.3118 20 10.0801 20 7.49367C20 3.90732 17.0927 1 13.5063 1C10.9199 1 8.68823 2.51185 7.64391 4.69779ZM9.34804 4.62596C13.1085 4.88661 16.1134 7.89152 16.374 11.652C17.6935 10.7403 18.557 9.21723 18.557 7.49367C18.557 4.70428 16.2957 2.44304 13.5063 2.44304C11.7828 2.44304 10.2597 3.30655 9.34804 4.62596ZM8.81646 6.05063C5.42935 6.05063 2.68355 8.79643 2.68355 12.1835C2.68355 15.5707 5.42935 18.3165 8.81646 18.3165C12.2036 18.3165 14.9494 15.5707 14.9494 12.1835C14.9494 8.79643 12.2036 6.05063 8.81646 6.05063ZM8.81285 9.17722C9.21133 9.17683 9.53467 9.49956 9.53506 9.89804L9.53678 11.6926C9.53782 12.7825 8.65456 13.6667 7.56463 13.6667H7.52174C7.12325 13.6667 6.80022 13.3436 6.80022 12.9451C6.80022 12.5467 7.12325 12.2236 7.52174 12.2236H7.56463C7.85705 12.2236 8.09402 11.9864 8.09374 11.694L8.09202 9.89943C8.09164 9.50094 8.41436 9.1776 8.81285 9.17722ZM5.99853 9.32954C6.39701 9.32954 6.72005 9.65257 6.72005 10.0511V10.8127C6.72005 11.2111 6.39701 11.5342 5.99853 11.5342C5.60005 11.5342 5.27701 11.2111 5.27701 10.8127V10.0511C5.27701 9.65257 5.60005 9.32954 5.99853 9.32954ZM11.6344 9.32954C12.0329 9.32954 12.3559 9.65257 12.3559 10.0511V10.8127C12.3559 11.2111 12.0329 11.5342 11.6344 11.5342C11.2359 11.5342 10.9129 11.2111 10.9129 10.8127V10.0511C10.9129 9.65257 11.2359 9.32954 11.6344 9.32954ZM19.2785 14.2278C19.677 14.2278 20 14.5509 20 14.9494V16.2293C20 16.7432 20 17.1721 19.9714 17.5225C19.9415 17.8879 19.877 18.231 19.7116 18.5555C19.458 19.0533 19.0533 19.458 18.5555 19.7116C18.231 19.877 17.8879 19.9415 17.5225 19.9714C17.1721 20 16.7432 20 16.2293 20H14.9494C14.5509 20 14.2278 19.677 14.2278 19.2785C14.2278 18.88 14.5509 18.557 14.9494 18.557H16.2C16.7507 18.557 17.1203 18.5564 17.405 18.5331C17.6812 18.5106 17.8132 18.4703 17.9004 18.4259C18.1266 18.3106 18.3106 18.1266 18.4259 17.9004C18.4703 17.8132 18.5106 17.6812 18.5331 17.405C18.5564 17.1203 18.557 16.7507 18.557 16.2V14.9494C18.557 14.5509 18.88 14.2278 19.2785 14.2278ZM6.64792 14.9073C6.82614 14.5509 7.25955 14.4064 7.61595 14.5846C8.37168 14.9625 9.26124 14.9625 10.017 14.5846C10.3734 14.4064 10.8068 14.5509 10.985 14.9073C11.1632 15.2637 11.0188 15.6971 10.6624 15.8753C9.50035 16.4564 8.13257 16.4564 6.97056 15.8753C6.61415 15.6971 6.4697 15.2637 6.64792 14.9073Z"
      fill="currentColor"
    />
  </svg>
);

export const VoiceCloneIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M1.66671 18.3333C1.20647 18.3333 0.827996 17.9588 0.885368 17.5021C1.069 16.0405 1.73329 14.672 2.786 13.6193C4.03624 12.369 5.73193 11.6667 7.50004 11.6667C9.26815 11.6667 10.9638 12.369 12.2141 13.6193C13.2668 14.672 13.9311 16.0405 14.1147 17.5021C14.1721 17.9588 13.7936 18.3333 13.3334 18.3333C12.8731 18.3333 12.5071 17.9577 12.4308 17.5038C12.2594 16.4854 11.7754 15.5376 11.0356 14.7978C10.0979 13.8601 8.82612 13.3333 7.50004 13.3333C6.17396 13.3333 4.90219 13.8601 3.96451 14.7978C3.22467 15.5376 2.74063 16.4854 2.56931 17.5038C2.49295 17.9577 2.12694 18.3333 1.66671 18.3333ZM7.50004 10.8333C4.73754 10.8333 2.50004 8.59583 2.50004 5.83333C2.50004 3.07083 4.73754 0.833334 7.50004 0.833334C10.2625 0.833334 12.5 3.07083 12.5 5.83333C12.5 8.59583 10.2625 10.8333 7.50004 10.8333ZM7.50004 9.16667C9.34171 9.16667 10.8334 7.675 10.8334 5.83333C10.8334 3.99167 9.34171 2.5 7.50004 2.5C5.65837 2.5 4.16671 3.99167 4.16671 5.83333C4.16671 7.675 5.65837 9.16667 7.50004 9.16667ZM17.9567 0.653334C18.7552 2.26319 19.1694 4.03633 19.1667 5.83333C19.1667 7.69417 18.7309 9.4525 17.9567 11.0133L16.5859 10.0167C17.1902 8.70497 17.5021 7.27756 17.5 5.83333C17.5 4.34 17.1725 2.9225 16.5859 1.65L17.9567 0.653334ZM15.205 2.65333C15.6212 3.6618 15.8347 4.74236 15.8334 5.83333C15.8346 6.92403 15.6211 8.00429 15.205 9.0125L13.8075 7.99583C14.0459 7.29979 14.1673 6.56906 14.1667 5.83333C14.1676 5.09737 14.0466 4.36635 13.8084 3.67L15.205 2.65333Z"
      fill="currentColor"
    />
  </svg>
);

export const CreativeLibrary = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M1.5 3.375V15.375L3.375 7.875H14.8125V5.625C14.8125 5.21078 14.4767 4.875 14.0625 4.875H9L7.125 2.625H2.25C1.83579 2.625 1.5 2.96079 1.5 3.375Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 15.375L16.5 7.875H3.30469L1.5 15.375H15Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const CreativeLibrarySelectedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M1.5 3.375V15.375L3.375 7.875H14.8125V5.625C14.8125 5.21078 14.4767 4.875 14.0625 4.875H9L7.125 2.625H2.25C1.83579 2.625 1.5 2.96079 1.5 3.375Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 15.375L16.5 7.875H3.30469L1.5 15.375H15Z"
      fill="white"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const AIRemovalIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_2225_10155)">
      <path
        d="M19.1667 18.3333H0.833333C0.333333 18.3333 9.31323e-09 18.6667 9.31323e-09 19.1667C9.31323e-09 19.6667 0.333333 20 0.833333 20H19.1667C19.6667 20 20 19.6667 20 19.1667C20 18.6667 19.6667 18.3333 19.1667 18.3333ZM3.41667 16.4167C3.58333 16.5833 3.83333 16.6667 4.08333 16.6667H10.75C11 16.6667 11.1667 16.5833 11.3333 16.4167L19.75 8C19.9167 7.83333 20 7.58333 20 7.41667C20 7.25 19.9167 7 19.75 6.83333L13.1667 0.25C12.8333 -0.0833333 12.3333 -0.0833333 12 0.25L0.25 12C-0.0833333 12.3333 -0.0833333 12.8333 0.25 13.1667L3.41667 16.4167ZM12.5833 2L17.9167 7.33333L13.1667 12.0833L7.91667 6.75L12.5833 2ZM6.75 7.91667L12.0833 13.25L10.3333 15H4.33333L1.91667 12.5833L6.75 7.91667Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2225_10155">
        <rect width="20" height="20" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

export const MyProject = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M2.40234 6.91015C2.77027 6.91015 3.06783 6.59543 3.06783 6.20627V3.65444C3.06783 3.51834 3.17237 3.40776 3.30105 3.40776H4.69032C4.77476 3.40776 4.85317 3.45667 4.89338 3.53535L5.43221 4.55609C5.70765 5.07921 6.23239 5.40457 6.79936 5.40457H16.7032C16.8319 5.40457 16.9364 5.51515 16.9364 5.65125V6.20627C16.9364 6.59543 17.234 6.91015 17.6019 6.91015C17.9698 6.91015 18.2674 6.59543 18.2674 6.20627V5.65125C18.2674 4.73897 17.5657 3.99681 16.7032 3.99681H6.79936C6.71492 3.99681 6.63651 3.9479 6.5963 3.86922L6.05748 2.84848C5.78204 2.32536 5.25729 2 4.69032 2H3.30105C2.43853 2 1.73686 2.74216 1.73686 3.65444V6.20627C1.73686 6.59543 2.03442 6.91015 2.40234 6.91015ZM18.6313 7.76715C18.3398 7.40989 17.9176 7.20574 17.4712 7.20574H2.53102C2.08468 7.20574 1.66247 7.40989 1.37094 7.76715C1.07942 8.1244 0.950743 8.59649 1.01709 9.0622L2.0887 16.622C2.20129 17.4216 2.83863 18 3.60062 18H16.3976C17.1495 18 17.7989 17.4067 17.9095 16.622L18.9811 9.0622C19.0515 8.59649 18.9228 8.1244 18.6313 7.76715ZM17.6683 8.8538L16.5967 16.4136C16.5826 16.5157 16.4981 16.5922 16.3996 16.5922H3.60464C3.50612 16.5922 3.42369 16.5178 3.40761 16.4136L2.336 8.8538C2.32393 8.77087 2.36012 8.71345 2.38224 8.68581C2.40435 8.65816 2.45261 8.6135 2.53303 8.6135H17.4732C17.5517 8.6135 17.6019 8.65816 17.624 8.68581C17.6441 8.71345 17.6803 8.77087 17.6683 8.8538Z"
      fill="currentColor"
    />
    <path
      d="M12.8164 10.3066H7.18359C6.82617 10.3066 6.53711 10.5957 6.53711 10.9531C6.53711 11.3105 6.82617 11.5996 7.18359 11.5996H12.8145C13.1719 11.5996 13.4609 11.3105 13.4609 10.9531C13.4609 10.5957 13.1738 10.3066 12.8164 10.3066Z"
      fill="currentColor"
    />
  </svg>
);

export const InviteFriendsIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.77482 0.204337C7.68095 -0.0683896 7.52824 -0.0680813 7.43554 0.205077L6.91204 1.74714C6.81935 2.02029 6.52004 2.31979 6.24688 2.41267L4.71629 2.93321C4.4432 3.02609 4.44264 3.17966 4.71506 3.27452L6.23646 3.80418C6.50888 3.89904 6.80855 4.19976 6.90242 4.47255L7.43338 6.01603C7.52719 6.28882 7.67947 6.28832 7.77167 6.01498L8.29005 4.47823C8.38219 4.20488 8.68094 3.90477 8.95386 3.81133L10.5084 3.27889C10.7813 3.18546 10.781 3.03337 10.5078 2.94098L8.97779 2.42346C8.7045 2.33101 8.40408 2.03226 8.31022 1.75953L7.77482 0.204337Z"
      fill="#745CFF"
    />
    <path
      d="M1.86498 7.44733C1.81134 7.29149 1.72407 7.29166 1.6711 7.44775L1.37196 8.32893C1.31899 8.48502 1.14796 8.65616 0.99187 8.70923L0.117249 9.00668C-0.0388065 9.05976 -0.0391236 9.14751 0.116544 9.20172L0.985914 9.50438C1.14158 9.55859 1.31283 9.73043 1.36647 9.88631L1.66987 10.7683C1.72348 10.9242 1.81049 10.9239 1.86318 10.7677L2.15939 9.88955C2.21205 9.73336 2.38276 9.56186 2.53871 9.50847L3.42704 9.20422C3.58299 9.15083 3.58282 9.06392 3.42666 9.01112L2.55239 8.7154C2.39623 8.66257 2.22456 8.49186 2.17092 8.33601L1.86498 7.44733Z"
      fill="#745CFF"
    />
    <g clipPath="url(#clip0_325_8024)">
      <path
        d="M15.659 9.13481H13.132C12.9573 9.13481 12.8231 9.09426 12.7295 9.01314C12.6359 8.93203 12.5704 8.82908 12.533 8.70429C12.4956 8.5795 12.4768 8.43911 12.4768 8.28312C12.4768 8.12714 12.4893 7.98051 12.5143 7.84324C12.5267 7.70597 12.5517 7.55622 12.5891 7.394C12.6266 7.23177 12.6796 7.0945 12.7483 6.98219C12.8169 6.86988 12.9074 6.79501 13.0197 6.75757C13.132 6.72013 13.2692 6.75133 13.4315 6.85116C13.6187 6.96347 13.8308 7.08514 14.0679 7.21617C14.305 7.3472 14.5359 7.47823 14.7605 7.60926C14.9851 7.74029 15.1941 7.85884 15.3876 7.96491C15.581 8.07098 15.7276 8.15522 15.8274 8.21761C15.9522 8.30496 16.0458 8.40167 16.1082 8.50775C16.1706 8.61382 16.1956 8.71365 16.1831 8.80724C16.1706 8.90083 16.1207 8.97883 16.0333 9.04122C15.946 9.10362 15.8212 9.13481 15.659 9.13481ZM17.119 9.1161H19.6273C19.802 9.1161 19.9361 9.07554 20.0297 8.99443C20.1233 8.91331 20.1888 8.81036 20.2263 8.68557C20.2637 8.56078 20.2824 8.42039 20.2824 8.26441C20.2824 8.10842 20.2762 7.96179 20.2637 7.82452C20.2388 7.68725 20.2107 7.54063 20.1795 7.38464C20.1483 7.22865 20.0984 7.0945 20.0297 6.98219C19.9611 6.86988 19.8706 6.79501 19.7583 6.75757C19.646 6.72013 19.5087 6.74509 19.3465 6.83244C19.1593 6.94475 18.9472 7.06642 18.7101 7.19745C18.473 7.32848 18.239 7.45951 18.0081 7.59054C17.7773 7.72157 17.5651 7.84012 17.3717 7.94619C17.1783 8.05226 17.0379 8.1365 16.9505 8.19889C16.8133 8.28624 16.7134 8.38296 16.6511 8.48903C16.5887 8.5951 16.5637 8.69493 16.5762 8.78852C16.5887 8.88212 16.6386 8.96011 16.7259 9.0225C16.8133 9.0849 16.9443 9.1161 17.119 9.1161ZM15.3969 10.3515H9.96856C9.56923 10.3515 9.31029 10.417 9.19174 10.5481C9.07319 10.6791 9.01392 10.8881 9.01392 11.1751V12.8224C9.01392 13.1343 9.07943 13.3652 9.21046 13.5149C9.34149 13.6647 9.60043 13.7396 9.98728 13.7396H15.3969V10.3515ZM17.4372 10.3515H22.7907C23.19 10.3515 23.4615 10.4295 23.605 10.5855C23.7485 10.7415 23.8202 10.963 23.8202 11.25V12.8598C23.8202 13.1593 23.7547 13.3808 23.6237 13.5243C23.4927 13.6678 23.2337 13.7396 22.8469 13.7396H17.4372V10.3515ZM15.3969 14.7316H9.65034V17.8015V19.0182V20.16V21.1334V21.8072C9.65034 22.4436 9.83129 22.9366 10.1932 23.286C10.5551 23.6354 11.1166 23.8101 11.8778 23.8101H15.3969V14.7316ZM17.4372 14.7316H23.1651V21.7511C23.1526 22.3875 22.9717 22.8898 22.6222 23.2579C22.2728 23.626 21.7175 23.8101 20.9563 23.8101H17.4372V14.7316Z"
        fill="#745CFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_325_8024">
        <rect
          width="19.2594"
          height="19.2594"
          fill="white"
          transform="translate(6.74057 6.74072)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const UploadIcon = () => (
  <div className="w-[30px] h-[30px] rounded-full bg-[#4931FA] flex justify-center items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M6.75 4.5L9 2.25M9 2.25L11.25 4.5M9 2.25V9.75M5.25017 7.5C4.55126 7.5 4.2018 7.5 3.92615 7.61418C3.55861 7.76642 3.26642 8.05861 3.11418 8.42615C3 8.7018 3 9.05109 3 9.75V13.35C3 14.1901 3 14.6098 3.16349 14.9307C3.3073 15.2129 3.5366 15.4429 3.81885 15.5867C4.1394 15.75 4.55925 15.75 5.39768 15.75H12.6027C13.4411 15.75 13.8604 15.75 14.1809 15.5867C14.4632 15.4429 14.6929 15.2129 14.8367 14.9307C15 14.6101 15 14.1908 15 13.3523V9.75C15 9.05109 14.9999 8.7018 14.8857 8.42615C14.7335 8.05861 14.4416 7.76642 14.074 7.61418C13.7984 7.5 13.4489 7.5 12.75 7.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);

export const EnhanceIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="currentColor"
  >
    <path
      d="M14.9629 0C15.7684 0 16.5409 0.319984 17.1104 0.889558C17.68 1.45913 18 2.23164 18 3.03714V14.9629C18 15.7684 17.68 16.5409 17.1104 17.1104C16.5409 17.68 15.7684 18 14.9629 18H3.03714C2.23164 18 1.45913 17.68 0.889558 17.1104C0.319984 16.5409 0 15.7684 0 14.9629V3.03714C7.10401e-09 2.23164 0.319984 1.45913 0.889558 0.889558C1.45913 0.319984 2.23164 7.10401e-09 3.03714 0H14.9629ZM14.9629 1.60229H3.03714C2.84874 1.60229 2.66219 1.6394 2.48813 1.71152C2.31408 1.78363 2.15594 1.88933 2.02275 2.02258C1.88955 2.15583 1.78392 2.31401 1.71187 2.48809C1.63983 2.66217 1.60278 2.84874 1.60286 3.03714V14.9629C1.60286 15.3433 1.75397 15.7081 2.02295 15.977C2.29193 16.246 2.65675 16.3971 3.03714 16.3971H14.9629C15.3433 16.3971 15.7081 16.246 15.977 15.977C16.246 15.7081 16.3971 15.3433 16.3971 14.9629V3.03714C16.3971 2.65675 16.246 2.29193 15.977 2.02295C15.7081 1.75397 15.3433 1.60286 14.9629 1.60286V1.60229ZM5.048 5.70514V8.34571H6.83657V5.70457H8.52229V12.5617H6.83657V9.84571H5.048V12.5623H3.36229V5.70514H5.048ZM12.2457 5.70514C12.9611 5.70514 13.6286 5.904 14.0966 6.37886C14.9011 7.17657 14.812 8.05714 14.812 9.13657C14.812 10.2097 14.9011 11.0897 14.0966 11.888C13.628 12.3623 12.9611 12.5623 12.2451 12.5623H9.70686V5.70514H12.2457ZM12.1354 7.204H11.3926V11.0623H12.1354C12.5554 11.0623 12.7891 10.9046 12.9406 10.6771C13.0777 10.4846 13.1263 10.2989 13.1263 9.13657V9.00171C13.1223 7.95886 13.0726 7.77429 12.9406 7.58914C12.7891 7.36229 12.5554 7.204 12.1354 7.204Z"
      fill="currentColor"
    />
  </svg>
);

export const R2KIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="2.75"
      y="4.75"
      width="18.5"
      height="14.5"
      rx="2.25"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M15.0311 10.0908H16.7293C17.484 10.0908 18.0501 10.299 18.4404 10.7154C18.8113 11.1058 19 11.6719 19 12.4136C19 13.1488 18.8113 13.7149 18.4404 14.1118C18.0501 14.5282 17.484 14.7364 16.7293 14.7364H15.0311V10.0908ZM15.7923 10.7415V14.0858H16.5861C17.1652 14.0858 17.5881 13.9491 17.8549 13.6824C18.1151 13.4091 18.2453 12.9862 18.2453 12.4136C18.2453 11.828 18.1151 11.3986 17.8549 11.1384C17.5881 10.8716 17.1652 10.7415 16.5861 10.7415H15.7923Z"
      fill="currentColor"
    />
    <path
      d="M10.2402 10.0908H11.0015V12.0297H13.3568V10.0908H14.118V14.7364H13.3568V12.6804H11.0015V14.7364H10.2402V10.0908Z"
      fill="currentColor"
    />
    <path
      d="M7.25773 9.99951C7.96693 9.99951 8.52648 10.2272 8.93639 10.6892C9.32677 11.1251 9.52197 11.7042 9.52197 12.4199C9.52197 13.1161 9.33328 13.6821 8.96892 14.1116C9.13809 14.3328 9.31376 14.567 9.48293 14.8143L8.98844 15.2437C8.81277 14.9899 8.6436 14.7492 8.47443 14.528C8.1361 14.7232 7.72619 14.8273 7.25773 14.8273C6.54202 14.8273 5.98247 14.593 5.57907 14.1376C5.18869 13.6952 5 13.1226 5 12.4199C5 11.7107 5.18869 11.1381 5.57907 10.6957C5.98247 10.2272 6.54202 9.99951 7.25773 9.99951ZM7.25773 10.6697C6.77625 10.6697 6.40539 10.8323 6.13862 11.1577C5.88487 11.47 5.76125 11.8864 5.76125 12.4199C5.76125 12.9469 5.88487 13.3633 6.13862 13.6756C6.39888 13.9945 6.77625 14.1571 7.25773 14.1571C7.56353 14.1571 7.82379 14.0921 8.04501 13.9684C7.81078 13.6821 7.58956 13.4284 7.37485 13.2007L7.81728 12.7712C8.04501 13.012 8.27273 13.2657 8.49395 13.526C8.66312 13.2397 8.75421 12.8688 8.75421 12.4199C8.75421 11.8734 8.62408 11.4439 8.37033 11.1316C8.11007 10.8193 7.73921 10.6697 7.25773 10.6697Z"
      fill="currentColor"
    />
  </svg>
);

export const R4KIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="2.75"
      y="4.75"
      width="18.5"
      height="14.5"
      rx="2.25"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M14.8956 10.9995H16.6518C17.4323 10.9995 18.0176 11.2148 18.4213 11.6454C18.8049 12.0492 19 12.6345 19 13.4016C19 14.1619 18.8049 14.7473 18.4213 15.1577C18.0176 15.5883 17.4323 15.8037 16.6518 15.8037H14.8956V10.9995ZM15.6828 11.6724V15.1308H16.5037C17.1026 15.1308 17.5399 14.9895 17.8158 14.7136C18.0849 14.431 18.2195 13.9937 18.2195 13.4016C18.2195 12.796 18.0849 12.3519 17.8158 12.0828C17.5399 11.8069 17.1026 11.6724 16.5037 11.6724H15.6828Z"
      fill="currentColor"
    />
    <path
      d="M9.94124 10.9995H10.7285V13.0046H13.1642V10.9995H13.9514V15.8037H13.1642V13.6775H10.7285V15.8037H9.94124V10.9995Z"
      fill="currentColor"
    />
    <path
      d="M5 10.9995H5.78723V13.9937C5.78723 14.4109 5.88143 14.7136 6.07656 14.9155C6.26496 15.1106 6.57447 15.2116 6.99836 15.2116C7.41553 15.2116 7.72504 15.1106 7.92017 14.9155C8.10857 14.7136 8.20949 14.4109 8.20949 13.9937V10.9995H8.99673V13.9802C8.99673 14.606 8.82179 15.0837 8.4719 15.4134C8.12202 15.7364 7.63084 15.8979 6.99836 15.8979C6.35916 15.8979 5.86798 15.7364 5.53155 15.4201C5.17494 15.0837 5 14.606 5 13.9802V10.9995Z"
      fill="currentColor"
    />
    <path
      d="M18.0371 7H18.5804L17.4276 8.12344L18.753 9.62136H18.1729L17.1376 8.40614L16.8182 8.7182V9.62136H16.3886V7H16.8182V8.23725L18.0371 7Z"
      fill="currentColor"
    />
    <path
      d="M15.2813 7H15.6741V8.7182H16.0633V9.05964H15.6741V9.62136H15.2666V9.05964H14V8.65212L15.2813 7ZM15.2556 7.54336L14.3488 8.7182H15.2666V7.54336H15.2556Z"
      fill="currentColor"
    />
  </svg>
);

export const R8KIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="2.75"
      y="4.75"
      width="18.5"
      height="14.5"
      rx="2.25"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M14.8956 10.9995H16.6518C17.4323 10.9995 18.0176 11.2148 18.4213 11.6454C18.8049 12.0492 19 12.6345 19 13.4016C19 14.1619 18.8049 14.7473 18.4213 15.1577C18.0176 15.5883 17.4323 15.8037 16.6518 15.8037H14.8956V10.9995ZM15.6828 11.6724V15.1308H16.5037C17.1026 15.1308 17.5399 14.9895 17.8158 14.7136C18.0849 14.431 18.2195 13.9937 18.2195 13.4016C18.2195 12.796 18.0849 12.3519 17.8158 12.0828C17.5399 11.8069 17.1026 11.6724 16.5037 11.6724H15.6828Z"
      fill="currentColor"
    />
    <path
      d="M9.94124 10.9995H10.7285V13.0046H13.1642V10.9995H13.9514V15.8037H13.1642V13.6775H10.7285V15.8037H9.94124V10.9995Z"
      fill="currentColor"
    />
    <path
      d="M5 10.9995H5.78723V13.9937C5.78723 14.4109 5.88143 14.7136 6.07656 14.9155C6.26496 15.1106 6.57447 15.2116 6.99836 15.2116C7.41553 15.2116 7.72504 15.1106 7.92017 14.9155C8.10857 14.7136 8.20949 14.4109 8.20949 13.9937V10.9995H8.99673V13.9802C8.99673 14.606 8.82179 15.0837 8.4719 15.4134C8.12202 15.7364 7.63084 15.8979 6.99836 15.8979C6.35916 15.8979 5.86798 15.7364 5.53155 15.4201C5.17494 15.0837 5 14.606 5 13.9802V10.9995Z"
      fill="currentColor"
    />
    <path
      d="M17.8865 7.0498H18.4159L17.2928 8.14429L18.584 9.60361H18.0189L17.0102 8.4197L16.6991 8.72372V9.60361H16.2806V7.0498H16.6991V8.25517L17.8865 7.0498Z"
      fill="currentColor"
    />
    <path
      d="M14.9586 7C15.2304 7 15.4486 7.07154 15.6131 7.21818C15.7562 7.34695 15.8313 7.5079 15.8313 7.70104C15.8313 7.82981 15.8027 7.94069 15.7455 8.0301C15.6811 8.1231 15.5881 8.19821 15.4629 8.24829V8.25544C15.5809 8.28763 15.6847 8.35917 15.7705 8.47005C15.8671 8.59165 15.9171 8.73115 15.9171 8.88853C15.9171 9.11744 15.8313 9.29985 15.6668 9.44292C15.4987 9.58242 15.2626 9.65395 14.9586 9.65395C14.651 9.65395 14.4149 9.58242 14.2504 9.44292C14.0823 9.29985 14 9.11744 14 8.88853C14 8.73115 14.0465 8.59165 14.1466 8.47005C14.2325 8.35917 14.3326 8.28763 14.4542 8.25544V8.24829C14.3255 8.19821 14.2325 8.1231 14.1717 8.0301C14.1145 7.94069 14.0858 7.82981 14.0858 7.70104C14.0858 7.5079 14.1574 7.34695 14.304 7.21818C14.465 7.07154 14.6832 7 14.9586 7ZM14.9586 7.33264C14.8083 7.33264 14.6867 7.37198 14.5973 7.45425C14.5186 7.52578 14.4793 7.61162 14.4793 7.71535C14.4793 7.83338 14.5115 7.92638 14.5759 7.99434C14.6545 8.0766 14.7797 8.11952 14.9586 8.11952C15.1338 8.11952 15.2626 8.0766 15.3413 7.99434C15.4057 7.92638 15.4379 7.83338 15.4379 7.71535C15.4379 7.61162 15.3985 7.52578 15.3198 7.45425C15.2268 7.37198 15.1088 7.33264 14.9586 7.33264ZM14.9586 8.4307C14.7797 8.4307 14.6438 8.47362 14.5508 8.55946C14.4578 8.64173 14.4149 8.75261 14.4149 8.88853C14.4149 9.01729 14.4614 9.12101 14.558 9.1997C14.651 9.27839 14.7833 9.31774 14.9586 9.31774C15.1303 9.31774 15.2662 9.27481 15.3663 9.19613C15.4557 9.11744 15.5022 9.01729 15.5022 8.88853C15.5022 8.75261 15.4557 8.64173 15.3699 8.56304C15.2733 8.47362 15.1374 8.4307 14.9586 8.4307Z"
      fill="currentColor"
    />
  </svg>
);

export const ViralRemakeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M12.4952 3.232H16.768V7.50568H12.4952V3.232ZM11.4939 2C11.4327 2 11.374 2.02431 11.3307 2.06758C11.2875 2.11085 11.2632 2.16954 11.2632 2.23074V8.50695C11.2632 8.56814 11.2875 8.62683 11.3307 8.6701C11.374 8.71337 11.4327 8.73768 11.4939 8.73768H17.7693C17.8305 8.73768 17.8891 8.71337 17.9324 8.6701C17.9757 8.62683 18 8.56814 18 8.50695V2.23074C18 2.16954 17.9757 2.11085 17.9324 2.06758C17.8891 2.02431 17.8305 2 17.7693 2H11.4939ZM3.232 12.4943H7.50484V16.768H3.232V12.4943ZM2.23074 11.2623C2.16954 11.2623 2.11085 11.2866 2.06758 11.3299C2.02431 11.3732 2 11.4319 2 11.4931V17.7693C2 17.8305 2.02431 17.8891 2.06758 17.9324C2.11085 17.9757 2.16954 18 2.23074 18H8.5061C8.5673 18 8.62599 17.9757 8.66926 17.9324C8.71253 17.8891 8.73684 17.8305 8.73684 17.7693V11.4931C8.73684 11.4319 8.71253 11.3732 8.66926 11.3299C8.62599 11.2866 8.5673 11.2623 8.5061 11.2623H2.23074ZM3.64547 4.42779H5.64126C3.89032 5.53533 2.60437 7.24444 2.02526 9.23368C1.99846 9.32528 1.99336 9.42185 2.01035 9.51576C2.02734 9.60967 2.06596 9.69834 2.12316 9.77474C2.18035 9.85113 2.25455 9.91316 2.33987 9.95592C2.4252 9.99867 2.5193 10.021 2.61474 10.0211H2.62147C2.75485 10.0209 2.88457 9.97743 2.99116 9.89726C3.09775 9.81709 3.17546 9.70451 3.21263 9.57642C3.99579 6.912 6.28126 4.832 9.13011 4.42189C9.28405 4.39993 9.42398 4.32051 9.52177 4.1996C9.61956 4.07869 9.66797 3.92524 9.65726 3.77011C9.6445 3.61271 9.57262 3.46599 9.45607 3.35944C9.33952 3.25289 9.18696 3.19442 9.02905 3.19579H3.632C3.54965 3.19576 3.46813 3.21224 3.39227 3.24428C3.31641 3.27632 3.24775 3.32325 3.19035 3.38229C3.13295 3.44134 3.08798 3.51131 3.0581 3.58805C3.02823 3.66478 3.01406 3.74674 3.01642 3.82905C3.02298 3.99078 3.09221 4.14362 3.20945 4.25521C3.3267 4.3668 3.48277 4.42839 3.64463 4.42695L3.64547 4.42779ZM16.3554 15.616H14.3596C16.1104 14.5081 17.396 12.7987 17.9747 10.8093C18.0015 10.7177 18.0066 10.6211 17.9897 10.5272C17.9727 10.4333 17.934 10.3446 17.8768 10.2682C17.8196 10.1918 17.7454 10.1298 17.6601 10.087C17.5748 10.0443 17.4807 10.022 17.3853 10.0219H17.3785C17.2454 10.0223 17.116 10.0659 17.0097 10.146C16.9034 10.2262 16.826 10.3386 16.7891 10.4665C16.0042 13.1301 13.7196 15.2109 10.8691 15.6219C10.7153 15.6442 10.5757 15.7238 10.4782 15.8446C10.3806 15.9655 10.3322 16.1187 10.3427 16.2737C10.3557 16.4309 10.4277 16.5774 10.5442 16.6838C10.6607 16.7902 10.8132 16.8485 10.9709 16.8472H16.368C16.5313 16.8455 16.6872 16.779 16.8014 16.6624C16.9157 16.5458 16.9789 16.3885 16.9773 16.2253C16.9756 16.062 16.9091 15.9061 16.7925 15.7918C16.6759 15.6776 16.5186 15.6143 16.3554 15.616Z"
      fill="currentColor"
    />
  </svg>
);

export const AIToolsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M6.75 2.25H3C2.58579 2.25 2.25 2.58579 2.25 3V6.75C2.25 7.16422 2.58579 7.5 3 7.5H6.75C7.16422 7.5 7.5 7.16422 7.5 6.75V3C7.5 2.58579 7.16422 2.25 6.75 2.25Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M6.75 10.5H3C2.58579 10.5 2.25 10.8358 2.25 11.25V15C2.25 15.4142 2.58579 15.75 3 15.75H6.75C7.16422 15.75 7.5 15.4142 7.5 15V11.25C7.5 10.8358 7.16422 10.5 6.75 10.5Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M13.125 7.5C14.5747 7.5 15.75 6.32475 15.75 4.875C15.75 3.42525 14.5747 2.25 13.125 2.25C11.6753 2.25 10.5 3.42525 10.5 4.875C10.5 6.32475 11.6753 7.5 13.125 7.5Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M15 10.5H11.25C10.8358 10.5 10.5 10.8358 10.5 11.25V15C10.5 15.4142 10.8358 15.75 11.25 15.75H15C15.4142 15.75 15.75 15.4142 15.75 15V11.25C15.75 10.8358 15.4142 10.5 15 10.5Z"
      stroke="white"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </svg>
);

export const AIToolsSelectedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M6.75 2.25H3C2.58579 2.25 2.25 2.58579 2.25 3V6.75C2.25 7.16423 2.58579 7.5 3 7.5H6.75C7.16423 7.5 7.5 7.16423 7.5 6.75V3C7.5 2.58579 7.16423 2.25 6.75 2.25Z"
      fill="white"
      stroke="white"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M6.75 10.5H3C2.58579 10.5 2.25 10.8358 2.25 11.25V15C2.25 15.4142 2.58579 15.75 3 15.75H6.75C7.16423 15.75 7.5 15.4142 7.5 15V11.25C7.5 10.8358 7.16423 10.5 6.75 10.5Z"
      fill="white"
      stroke="white"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M13.125 7.5C14.5748 7.5 15.75 6.32475 15.75 4.875C15.75 3.42525 14.5748 2.25 13.125 2.25C11.6753 2.25 10.5 3.42525 10.5 4.875C10.5 6.32475 11.6753 7.5 13.125 7.5Z"
      fill="white"
      stroke="white"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M15 10.5H11.25C10.8358 10.5 10.5 10.8358 10.5 11.25V15C10.5 15.4142 10.8358 15.75 11.25 15.75H15C15.4142 15.75 15.75 15.4142 15.75 15V11.25C15.75 10.8358 15.4142 10.5 15 10.5Z"
      fill="white"
      stroke="white"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </svg>
);
